import { render } from "./SegmentedProgressBar.vue?vue&type=template&id=03afb3ff"
import script from "./SegmentedProgressBar.vue?vue&type=script&lang=ts"
export * from "./SegmentedProgressBar.vue?vue&type=script&lang=ts"

import "./SegmentedProgressBar.vue?vue&type=style&index=0&id=03afb3ff&lang=scss"
script.render = render

export default script